import React from 'react';
import { Column } from '@ant-design/charts';
import { Card, Skeleton } from 'antd';

const ApiVolumeIntervalChart = ({ data, loading }) => {
  if (loading) return <Skeleton active paragraph={{ rows: 6 }} />;

  const config = {
    data,
    xField: 'hour',
    yField: 'total_calls',
    columnWidthRatio: 0.6,
    color: '#1890ff',
    xAxis: { label: { rotate: -45 } },
    tooltip: {
      formatter: (item) => ({
        name: 'Requests',
        value: item.total_calls
      })
    }
  };

  return (
    <Card title="API Request Volume (Grouped)">
      <Column {...config} height={300} />
    </Card>
  );
};

export default ApiVolumeIntervalChart;
